// extracted by mini-css-extract-plugin
export var active = "productfinder-seedandstrain-module--active--cd0e2";
export var error_message = "productfinder-seedandstrain-module--error_message--bca9a";
export var infoBox = "productfinder-seedandstrain-module--infoBox--fcb9a";
export var input_section = "productfinder-seedandstrain-module--input_section--c6c7d";
export var map_styles = "productfinder-seedandstrain-module--map_styles--43bf7";
export var product_category_container = "productfinder-seedandstrain-module--product_category_container--aa120";
export var product_results = "productfinder-seedandstrain-module--product_results--9604a";
export var scroll = "productfinder-seedandstrain-module--scroll--bca58";
export var search = "productfinder-seedandstrain-module--search--23c35";
export var search_section = "productfinder-seedandstrain-module--search_section--251d6";
export var two_columns = "productfinder-seedandstrain-module--two_columns--7406b";